import { AbstractStepController, ContextChange, DialogService, FlowStepHandleResult, HandleResultType, StepControl, StepControlType, TranslationService, WizardServiceLocator } from '@sdbn/common';
import { TileDefinition } from '../widgets/terminal/tile-selection/tile-selection.model';

export class DictionaryLookupSelectionController extends AbstractStepController {

  private dialogService: DialogService
  translationService: TranslationService;

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
    this.translationService = WizardServiceLocator.injector.get(TranslationService);

  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selectedTile') {
      this.handleSelectedProcessOption(this.dashboardContext.getContextValue('selectedTile'));
    }
  }

  onRegisterToDashboardContext() {
  }

  private handleSelectedProcessOption(selectedTile: TileDefinition) {
    this.wizardComponent.stopInactivityMonitoring();
    let targetField = this.wizardComponent.currentStep.dashboardConfiguration.targetField;
    this.dashboardContext.setContextValue(targetField, selectedTile.key);
    this.wizardComponent.next();
  }

  public handleFlow(): FlowStepHandleResult {

    let keys = this.translationService.getDictionaryKeysStartingWith(this.wizardComponent.currentStep.dashboardConfiguration.dictionaryKey);
    let restrictOptions: Array<string> = this.wizardComponent.currentStep.dashboardConfiguration.restrictOptions;
    let configuration = { selectOptions: new Array<TileDefinition>() }

    for (const key of keys) {
      let keyParts = key.split('.');
      if (restrictOptions != null && restrictOptions.length > 0) {
        if (restrictOptions.includes(keyParts[keyParts.length - 1])) {
          configuration.selectOptions.push(new TileDefinition({ titleDictionaryKey: key, key: keyParts[keyParts.length - 1] }));
        }
      } else {
        configuration.selectOptions.push(new TileDefinition({ titleDictionaryKey: key, key: keyParts[keyParts.length - 1] }));
      }

    }


    this.dashboardContext.setContextValue('dashboardConfiguration', configuration);

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {

    this.dialogService.showConfirm('tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message').afterClosed().subscribe(() => {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      });
  }

  public getControls(): StepControl[] {

    const controls = new Array<StepControl>();

    const spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    return controls;
  }
}
